"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MapPlaceholder() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="w-full bg-muted py-16 sm:py-24">
      <div ref={ref} className={`mx-auto max-w-screen-xl px-4 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-3 opacity-0"}`}>
        <div className="overflow-hidden rounded-lg border border-border bg-background shadow-soft">
          <div className="relative aspect-[16/9] w-full bg-secondary-light">
            <div className="absolute inset-0 flex items-center justify-center">
              <p className="text-muted-foreground text-sm font-medium">
                Map Preview
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}